import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <span
      className={`inline-flex items-center gap-2 font-mono2 text-[11px] font-medium uppercase tracking-[0.22em] ${
        dark ? "text-brand-orange" : "text-brand-deep"
      }`}
    >
      <span className="h-[7px] w-[7px] rounded-full bg-brand-orange animate-pulse" data-testid="eyebrow-dot" />
      {children}
    </span>
  );
}

export function SectionHead({ eyebrow, title, sub, dark = false, center = false }) {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2
          className={`font-display text-3xl sm:text-4xl lg:text-[2.9rem] font-bold tracking-tight leading-[1.12] mt-4 text-balance ${
            dark ? "text-white" : "text-brand-ink"
          }`}
        >
          {title}
        </h2>
      </Reveal>
      {sub ? (
        <Reveal delay={0.16}>
          <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
            {sub}
          </p>
        </Reveal>
      ) : null}
    </div>
  );
}
